import store from '../middleware/redux/store';
import { persistor } from '../middleware/redux/store';
import { resetAll } from '../middleware/redux/reducers/reset.reducer';

/**
 * Full logout — wipes everything and hard-navigates to "/".
 * Use this everywhere a session ends (explicit logout, remote termination,
 * password change, UNAUTHENTICATED error from Apollo).
 *
 * persistor.purge() is async but we fire-and-forget it: window.location.replace
 * navigates away immediately anyway, so the browser re-initialises clean.
 */
export const performFullLogout = () => {
    store.dispatch(resetAll());   // resets every Redux slice to initial state
    persistor.purge();            // clears redux-persist storage (persist:root)
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/');
};
